import React, { useState } from "react";
import Carousel from "react-bootstrap/Carousel";
import Styles from "./Carousel.module.scss";
import clsx from "clsx";

function ClientHomeCarousel() {
  const listItemCarousel = [
    {
          href: "https://trikytrungphung.net/news/:id12",
          src: "https://trikytrungphung.net/upload/20231229145332219.webp",
    },
    {
        href: "https://trikytrungphung.net/news/:id12",
        src: "https://trikytrungphung.net/upload/trungthublh.webp",
    },
  ];

  const [index, setIndex] = useState(0);
  const handleSelect = (selectedIndex, e) => {
    setIndex(selectedIndex);
  };

  const setUp = {
    interval: 50000,
    controls: true,
    slide: true,
    keyboard: true,
  };

  return (
    <Carousel
      className={clsx(Styles.mainCarousel, "w-100 img-fluid")}
      activeIndex={index}
      onSelect={handleSelect}
      {...setUp}
    >
      {listItemCarousel?.map((item, index) => {
        return (
          <Carousel.Item
            key={index}
            className={clsx(Styles.carouselItem, "w-100 img-fluid")}
          >
            <img
              className={clsx(Styles.carouselimg, "d-block w-100 img-fluid")}
              src={item.src}
              alt="First slide"
            />
          </Carousel.Item>
        );
      })}
    </Carousel>
  );
}

export default ClientHomeCarousel;
